<div class="profile__wrapper">
  <form [formGroup]="form" class="row">
    <div class="row">
      <div class="first-col col-sm-3">
        <fieldset [disabled]="!isEditable" class="form__fieldset photo-wrapper">
          <app-image-uploader
            [isEditable]="isEditable"
            [formControl]="file"
          ></app-image-uploader>
          <div class="content">
            <div>
              <label class="status-label" [class.red]="isFormer">Status </label>
              <div class="content_status dropdown__value">
                <p>{{ statusValue }}</p>
              </div>
            </div>
            <div class="content_employment">
              <label
                class="status-label"
                appMarkAsterisk
                [formGroup]="form"
                [controlName]="'employmentForm'"
                [touched]="form.get('employmentForm')!.touched"
                >Employment Type
              </label>
              <div>
                <app-dropdown
                  formControlName="employmentForm"
                  [items]="employmentForm"
                  [border]="'none'"
                  [isEditMode]="isEditable"
                ></app-dropdown>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('employmentForm', form) &&
                    form.get('employmentForm')!.hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
              </div>
            </div>
          </div>
        </fieldset>
        <div class="regular_data">
          <div
            class="pl-12 mb-16"
            [class.general__item]="dataCertResignation.length === 0"
          >
            <label class="medium">Working periods</label>

            <div class="general_form-table mt-0 mb-0">
              <app-table
                *ngIf="dataCertResignation.length"
                [tableType]="typeOfTable"
                [headers]="headersCertResignation"
                [content]="dataCertResignation"
                [showEditFields]="!isEditable"
                [showPlusIcon]="false"
                [deleteOnlyLastRow]="checkDeleteAvailable()"
                (rowAction)="onDeleteWorkingPeriod($event.index)"
              ></app-table>
              <button
                class="button button__add--normal table__btn"
                type="button"
                *ngIf="!isEditable"
                (click)="createWorkingPeriod()"
              ></button>
            </div>
          </div>
          <div
            class="pl-12 mb-16"
            *ngIf="isFemaleGender"
            [class.general__item]="dataCertMaternity.length === 0"
          >
            <label class="medium">Maternity period</label>
            <div class="general_form-table mb-3">
              <app-table
                *ngIf="dataCertMaternity.length"
                [tableType]="typeOfTable"
                [headers]="headersCertMaternity"
                [content]="dataCertMaternity"
                [showEditFields]="!isEditable && isAccountant"
                [editOnlyLastRow]="true"
                [deleteOnlyLastRow]="true"
                [editMenu]="'icon'"
                (rowAction)="
                  maternityTableActions(headersCertMaternity, $event)
                "
              ></app-table>
              <button
                *ngIf="
                  dataCertMaternity.length === 0 && !isEditable && isAccountant
                "
                class="button button__add--normal table__btn"
                type="button"
                (click)="maternityTableActions(headersCertMaternity)"
              ></button>
            </div>
          </div>
          <div
            class="pl-12 mb-16"
            [class.general__item]="dataCertLongTermLeave.length === 0"
          >
            <label class="medium">Longterm Leave</label>
            <div class="general_form-table">
              <app-table
                *ngIf="dataCertLongTermLeave.length"
                [tableType]="typeOfTable"
                [headers]="headersCertSabbatical"
                [content]="dataCertLongTermLeave"
                [showEditFields]="isAvailableForAction"
                [editOnlyLastRow]="true"
                [deleteOnlyLastRow]="true"
                [isSortTable]="false"
                [editMenu]="'icon'"
                (rowAction)="
                  longTermLeaveTableActions(headersCertSabbatical, $event)
                "
              ></app-table>
              <button
                *ngIf="isAvailableForAction"
                class="button button__add--normal table__btn"
                type="button"
                (click)="longTermLeaveTableActions(headersCertSabbatical)"
              ></button>
            </div>
          </div>
        </div>
        <fieldset [disabled]="!isEditable" class="form__fieldset">
          <div class="switch first-switch">
            <input
              type="checkbox"
              class="switch__checkbox"
              formControlName="unlimitedVacationDays"
            />
            <label class="switch__label">Unlimited vacation days</label>
          </div>
          <div class="switch">
            <input
              type="checkbox"
              class="switch__checkbox"
              formControlName="earlyVacationRegistration"
            />
            <label class="switch__label">Early vacation registration</label>
          </div>
        </fieldset>
      </div>
      <fieldset [disabled]="!isEditable" class="form__fieldset col-sm-8">
        <div class="row">
          <div class="col-sm-6">
            <div class="row mb-3 general__item">
              <label
                class="col-sm-3 d-flex"
                appMarkAsterisk
                [formGroup]="form"
                [controlName]="'firstName'"
                [touched]="form.get('firstName')!.touched"
                >Name
              </label>
              <div class="col-sm-7 general_form_input">
                <input
                  type="text"
                  class="input__basic"
                  placeholder=" "
                  formControlName="firstName"
                />
                <app-error-field
                  [displayError]="
                    isFieldInvalid('firstName', form) &&
                    form.get('firstName')!.hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('firstName', form) &&
                    form.get('firstName')!.hasError('forbiddenAphabet') &&
                    !form.get('firstName')!.hasError('whitespace')
                  "
                  [errorMessage]="'Latin symbols are required for this field'"
                ></app-error-field>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('firstName', form) &&
                    form.get('firstName')!.hasError('whitespace') &&
                    !form.get('firstName')!.hasError('required')
                  "
                  [errorMessage]="'Please remove spaces'"
                ></app-error-field>
                <app-error-field
                  [displayError]="
                    form.get('firstName')!.hasError('maxlength') &&
                    !form.get('firstName')!.hasError('whitespace') &&
                    !form.get('firstName')!.hasError('forbiddenAphabet')
                  "
                  [errorMessage]="'Max field length = 30'"
                ></app-error-field>
              </div>
            </div>
            <div class="row mb-3 general__item">
              <label
                class="col-sm-3 d-flex"
                appMarkAsterisk
                [formGroup]="form"
                [controlName]="'lastName'"
                [touched]="form.get('lastName')!.touched"
                >Surname
              </label>
              <div class="col-sm-7 general_form_input">
                <input
                  type="text"
                  class="input__basic"
                  placeholder=" "
                  formControlName="lastName"
                />
                <app-error-field
                  [displayError]="
                    isFieldInvalid('lastName', form) &&
                    form.get('lastName')!.hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('lastName', form) &&
                    form.get('lastName')!.hasError('forbiddenAphabet') &&
                    !form.get('lastName')!.hasError('whitespace')
                  "
                  [errorMessage]="'Latin symbols are required for this field'"
                ></app-error-field>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('lastName', form) &&
                    form.get('lastName')!.hasError('whitespace') &&
                    !form.get('lastName')!.hasError('required')
                  "
                  [errorMessage]="'Please remove spaces'"
                ></app-error-field>
                <app-error-field
                  [displayError]="
                    form.get('lastName')!.hasError('maxlength') &&
                    !form.get('lastName')!.hasError('whitespace') &&
                    !form.get('lastName')!.hasError('forbiddenAphabet')
                  "
                  [errorMessage]="'Max field length = 30'"
                ></app-error-field>
              </div>
            </div>
            <div class="row mb-3 general__item">
              <label
                class="col-sm-3 d-flex"
                appMarkAsterisk
                [formGroup]="form"
                [controlName]="'lastNameUA'"
                [touched]="form.get('lastNameUA')!.touched"
                >Прізвище
              </label>
              <div class="col-sm-7 general_form_input">
                <input
                  type="text"
                  class="input__basic"
                  placeholder=" "
                  formControlName="lastNameUA"
                />
                <app-error-field
                  [displayError]="
                    isFieldInvalid('lastNameUA', form) &&
                    form.get('lastNameUA')!.hasError('forbiddenAphabet') &&
                    !form.get('lastNameUA')!.hasError('whitespace')
                  "
                  [errorMessage]="'Cyrylic symbols are required for this field'"
                ></app-error-field>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('lastNameUA', form) &&
                    form.get('lastNameUA')!.hasError('whitespace') &&
                    !form.get('lastNameUA')!.hasError('required')
                  "
                  [errorMessage]="'Please remove spaces'"
                ></app-error-field>
                <app-error-field
                  [displayError]="
                    form.get('lastNameUA')!.hasError('maxlength') &&
                    !form.get('lastNameUA')!.hasError('whitespace') &&
                    !form.get('lastNameUA')!.hasError('forbiddenAphabet')
                  "
                  [errorMessage]="'Max field length = 30'"
                ></app-error-field>
              </div>
            </div>
            <div class="row mb-3 general__item">
              <label
                class="col-sm-3 d-flex"
                appMarkAsterisk
                [formGroup]="form"
                [controlName]="'firstNameUA'"
                [touched]="form.get('firstNameUA')!.touched"
                >Ім'я
              </label>
              <div class="col-sm-7 general_form_input">
                <input
                  type="text"
                  class="input__basic"
                  placeholder=" "
                  formControlName="firstNameUA"
                />
                <app-error-field
                  [displayError]="
                    isFieldInvalid('firstNameUA', form) &&
                    form.get('firstNameUA')!.hasError('forbiddenAphabet') &&
                    !form.get('firstNameUA')!.hasError('whitespace')
                  "
                  [errorMessage]="'Cyrylic symbols are required for this field'"
                ></app-error-field>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('firstNameUA', form) &&
                    form.get('firstNameUA')!.hasError('whitespace') &&
                    !form.get('firstNameUA')!.hasError('required')
                  "
                  [errorMessage]="'Please remove spaces'"
                ></app-error-field>
                <app-error-field
                  [displayError]="
                    form.get('firstNameUA')!.hasError('maxlength') &&
                    !form.get('firstNameUA')!.hasError('whitespace') &&
                    !form.get('firstNameUA')!.hasError('forbiddenAphabet')
                  "
                  [errorMessage]="'Max field length = 30'"
                ></app-error-field>
              </div>
            </div>
            <div class="row mb-3 general__item">
              <label
                class="col-sm-3 d-flex"
                appMarkAsterisk
                [formGroup]="form"
                [controlName]="'middleNameUA'"
                [touched]="form.get('middleNameUA')!.touched"
                >По батькові
              </label>
              <div class="col-sm-7 general_form_input">
                <input
                  type="text"
                  class="input__basic"
                  placeholder=" "
                  formControlName="middleNameUA"
                />
                <app-error-field
                  [displayError]="
                    isFieldInvalid('middleNameUA', form) &&
                    form.get('middleNameUA')!.hasError('forbiddenAphabet') &&
                    !form.get('middleNameUA')!.hasError('whitespace')
                  "
                  [errorMessage]="'Cyrylic symbols are required for this field'"
                ></app-error-field>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('middleNameUA', form) &&
                    form.get('middleNameUA')!.hasError('whitespace') &&
                    !form.get('middleNameUA')!.hasError('required')
                  "
                  [errorMessage]="'Please remove spaces'"
                ></app-error-field>
                <app-error-field
                  [displayError]="
                    form.get('middleNameUA')!.hasError('maxlength') &&
                    !form.get('middleNameUA')!.hasError('whitespace') &&
                    !form.get('middleNameUA')!.hasError('forbiddenAphabet')
                  "
                  [errorMessage]="'Max field length = 30'"
                ></app-error-field>
              </div>
            </div>
            <div class="row mb-3 general__item">
              <label class="col-sm-3">Gender</label>
              <div class="col-sm-7 general_form_input">
                <app-dropdown
                  ngDefaultControl
                  formControlName="gender"
                  [items]="gender"
                  [border]="isEditable ? 'classic' : 'none'"
                  [isEditMode]="isEditable"
                ></app-dropdown>
              </div>
            </div>
            <div class="row mb-3 general__item">
              <label
                class="col-sm-3"
                appMarkAsterisk
                [formGroup]="form"
                [controlName]="'department'"
                [touched]="form.get('department')!.touched"
                >Department</label
              >
              <div class="col-sm-7 general_form_input">
                <app-dropdown
                  formControlName="department"
                  [isMultiselect]="false"
                  [items]="departmentItems"
                  [border]="isEditable ? 'classic' : 'none'"
                  [isEditMode]="isEditable"
                ></app-dropdown>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('department', form) &&
                    form.get('department')!.hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
              </div>
            </div>
            <div
              class="row mb-3 general__item"
              *ngIf="isDepartmentSelected && isDepartmentDelivery"
            >
              <label
                class="col-sm-3"
                appMarkAsterisk
                [formGroup]="form"
                [controlName]="'subDepartment'"
                [touched]="form.get('subDepartment')!.touched"
                >Sub department</label
              >
              <div class="col-sm-7 general_form_input">
                <app-dropdown
                  ngDefaultControl
                  formControlName="subDepartment"
                  [items]="subDepartmentItems"
                  [border]="isEditable ? 'classic' : 'none'"
                  [isEditMode]="isEditable"
                ></app-dropdown>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('subDepartment', form) &&
                    form.get('subDepartment')!.hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
              </div>
            </div>
            <div
              class="row mb-3 general__item"
              *ngIf="
                isSubDepartment &&
                isDepartmentDelivery &&
                !isSubDepartmentManagement
              "
            >
              <label class="col-sm-3">Project manager</label>
              <div class="col-sm-7 general_form_input">
                <app-dropdown
                  ngDefaultControl
                  formControlName="projectManager"
                  [items]="pmItems"
                  [border]="isEditable ? 'classic' : 'none'"
                  [isEditMode]="isEditable"
                ></app-dropdown>
              </div>
            </div>

            <div class="row mb-3 general__item" *ngIf="isDepartmentSelected">
              <label
                class="col-sm-3"
                appMarkAsterisk
                [formGroup]="form"
                [controlName]="'position'"
                [touched]="form.get('position')!.touched"
                >Position</label
              >
              <div class="col-sm-7 general_form_input">
                <app-dropdown
                  ngDefaultControl
                  formControlName="position"
                  [items]="isSubDepartment ? subPositionItems : positionItems"
                  [border]="isEditable ? 'classic' : 'none'"
                  [isEditMode]="isEditable"
                ></app-dropdown>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('position', form) &&
                    form.get('position')!.hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
              </div>
            </div>
            <div
              class="row mb-3 general__item"
              *ngIf="isPositionSelected && isDepartmentSelected"
            >
              <label class="col-sm-3">Level</label>
              <div class="col-sm-7 general_form_input">
                <app-dropdown
                  ngDefaultControl
                  formControlName="qualificationLevel"
                  [items]="levelItems"
                  [border]="isEditable ? 'classic' : 'none'"
                  [isEditMode]="isEditable"
                ></app-dropdown>
              </div>
            </div>
            <div class="row mb-3 general__item">
              <label
                class="col-sm-3"
                appMarkAsterisk
                [formGroup]="form"
                [controlName]="'firstProject'"
                [touched]="form.get('firstProject')!.touched"
                >Project name
              </label>
              <div class="col-sm-7 general_form_input">
                <input
                  type="text"
                  class="input__basic"
                  placeholder=" "
                  formControlName="firstProject"
                />
                <app-error-field
                  [displayError]="
                    isFieldInvalid('firstProject', form) &&
                    form.get('firstProject')!.hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
                <app-error-field
                  [displayError]="
                    form.get('firstProject')!.hasError('maxlength')
                  "
                  [errorMessage]="'Max field length = 30'"
                ></app-error-field>
              </div>
            </div>

            <div class="row mb-3 general__item" *ngIf="!isContractor">
              <label
                class="col-sm-3"
                appMarkAsterisk
                [formGroup]="form"
                [controlName]="'hr'"
                [touched]="form.get('hr')!.touched"
                >HR</label
              >
              <div class="col-sm-7 general_form_input">
                <app-dropdown
                  ngDefaultControl
                  formControlName="hr"
                  [items]="hrItems"
                  [border]="isEditable ? 'classic' : 'none'"
                  [isEditMode]="isEditable"
                ></app-dropdown>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('hr', form) &&
                    form.get('hr')!.hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
              </div>
            </div>
            <div class="row mb-3 general__item">
              <label class="col-sm-3">PE</label>
              <div class="col-sm-7 general_form_input">
                <input
                  type="text"
                  class="input__basic disabled-field"
                  placeholder=" "
                  formControlName="pe"
                />
              </div>
            </div>
            <div class="row mb-3 general__item">
              <label class="col-sm-3">OS</label>
              <div class="col-sm-7 general_form_input">
                <app-dropdown
                  ngDefaultControl
                  formControlName="os"
                  [items]="osItems"
                  [border]="isEditable ? 'classic' : 'none'"
                  [isEditMode]="isEditable"
                ></app-dropdown>
              </div>
            </div>
            <div class="row mb-3 general__item" *ngIf="isContractor">
              <label
                class="col-sm-3 d-flex"
                appMarkAsterisk
                [formGroup]="form"
                [controlName]="'contractorWorkingHoursPerWeek'"
                [touched]="form.get('contractorWorkingHoursPerWeek')!.touched"
                >Amount of hours <br />
                (per week)
              </label>
              <div class="col-sm-7 general_form_input">
                <input
                  type="number"
                  class="input__basic"
                  placeholder=" "
                  formControlName="contractorWorkingHoursPerWeek"
                />
                <app-error-field
                  [displayError]="
                    isFieldInvalid('contractorWorkingHoursPerWeek', form) &&
                    form
                      .get('contractorWorkingHoursPerWeek')!
                      .hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
                <app-error-field
                  [displayError]="
                    form
                      .get('contractorWorkingHoursPerWeek')!
                      .hasError('max') ||
                    form.get('contractorWorkingHoursPerWeek')!.hasError('min')
                  "
                  [errorMessage]="'The value should be between 0 and 40'"
                ></app-error-field>
              </div>
            </div>
            <div class="row mb-3 general__item">
              <label class="col-sm-3">Key card number</label>
              <div class="col-sm-7 general_form_input">
                <input
                  type="text"
                  class="input__basic"
                  placeholder=" "
                  formControlName="cardNumber"
                  [mask]="cardMask"
                />
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="row mb-3 general__item">
              <label class="col-sm-3">Unit</label>
              <div class="col-sm-7 general_form_input">
                <app-dropdown
                  ngDefaultControl
                  formControlName="unit"
                  [items]="unit"
                  [border]="!isAccountant && isEditable ? 'classic' : 'none'"
                  [isEditMode]="!isAccountant && isEditable"
                  [disabl]="isAccountant"
                ></app-dropdown>
              </div>
            </div>
            <div class="row mb-3 general__item">
              <label
                class="col-sm-3"
                appMarkAsterisk
                [formGroup]="form"
                [controlName]="'lineManager'"
                [touched]="form.get('lineManager')!.touched"
                >Line manager
              </label>
              <div class="col-sm-7 general_form_input">
                <app-dropdown
                  ngDefaultControl
                  formControlName="lineManager"
                  [items]="lineManager"
                  [border]="isEditable ? 'classic' : 'none'"
                  [isEditMode]="isEditable"
                ></app-dropdown>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('lineManager', form) &&
                    form.get('lineManager')!.hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
              </div>
            </div>
            <ng-container *ngIf="!isHiddenForRecruiter">
              <div class="row mb-3 general__item">
                <label
                  class="col-sm-3 d-flex"
                  appMarkAsterisk
                  [formGroup]="form"
                  [controlName]="'workEmail'"
                  [touched]="form.get('workEmail')!.touched"
                  >Work email</label
                >
                <div class="col-sm-7 general_form_input">
                  <input
                    type="text"
                    class="input__basic"
                    [class.disabled-field]="!isAdmin && !isHrManager"
                    placeholder=" "
                    formControlName="workEmail"
                  />
                  <app-error-field
                    [displayError]="
                      form.get('workEmail')!.hasError('maxlength')
                    "
                    [errorMessage]="'Max field length = 30'"
                  ></app-error-field>
                  <app-error-field
                    [displayError]="
                      form.get('workEmail')!.hasError('pattern') &&
                      !form.get('workEmail')!.hasError('maxlength')
                    "
                    [errorMessage]="'Please enter a valid email'"
                  ></app-error-field>
                </div>
              </div>
              <div class="row mb-3 general__item">
                <label
                  class="col-sm-3 d-flex"
                  appMarkAsterisk
                  [formGroup]="form"
                  [controlName]="'anukoLogin'"
                  [touched]="form.get('anukoLogin')!.touched"
                  >Anuko login</label
                >
                <div class="col-sm-7 general_form_input">
                  <input
                    type="text"
                    class="input__basic"
                    [class.disabled-field]="!isAdmin && !isHrManager"
                    placeholder=" "
                    formControlName="anukoLogin"
                  />
                  <app-error-field
                    [displayError]="
                      form.get('anukoLogin')!.hasError('maxlength')
                    "
                    [errorMessage]="'Max field length = 30'"
                  ></app-error-field>
                  <app-error-field
                    [displayError]="form.get('anukoLogin')!.hasError('pattern')"
                    [errorMessage]="'Please enter only letters'"
                  ></app-error-field>
                </div></div
            ></ng-container>

            <div class="row mb-3 general__item">
              <label
                class="col-sm-3 d-flex"
                appMarkAsterisk
                [formGroup]="form"
                [controlName]="'dateOfJoining'"
                [touched]="form.get('dateOfJoining')!.touched"
                >Start date
              </label>
              <div
                class="col-sm-7 general_form_input"
                [class.read-mode]="!isEditable"
                [class.pl-8]="!isEditable"
              >
                <app-datepicker
                  ngDefaultControl
                  [iconLeft]="true"
                  formControlName="dateOfJoining"
                  [showIcon]="isEditable"
                  [fontSize]="13"
                  [isDisabled]="!isPending"
                ></app-datepicker>
                <app-error-field
                  [displayError]="isFieldInvalid('dateOfJoining', form)"
                  [errorMessage]="'The field is required'"
                ></app-error-field>
              </div>
            </div>
            <ng-container *ngIf="!isHiddenForRecruiter">
              <div class="row mb-3 general__item">
                <label
                  class="col-sm-3 d-flex"
                  appMarkAsterisk
                  [formGroup]="form"
                  [controlName]="'probationEndDate'"
                  [touched]="form.get('probationEndDate')!.touched"
                  >Probation end date
                </label>
                <div
                  class="col-sm-7 general_form_input"
                  [class.read-mode]="!isEditable"
                  [class.pl-8]="!isEditable"
                >
                  <app-datepicker
                    ngDefaultControl
                    [iconLeft]="true"
                    formControlName="probationEndDate"
                    [fontSize]="13"
                    [minDeadLine]="startDate"
                    [deadLine]="startDate"
                    [isDisabled]="!form.controls['dateOfJoining'].value"
                    [showIcon]="isEditable"
                  ></app-datepicker>
                  <app-error-field
                    [displayError]="isFieldInvalid('probationEndDate', form)"
                    [errorMessage]="'The field is required'"
                  ></app-error-field>
                </div>
              </div>
              <div class="row mb-3 general__item">
                <label class="col-sm-3">Probation end status</label>
                <div class="col-sm-7 general_form_input">
                  <app-dropdown
                    ngDefaultControl
                    formControlName="probationStatus"
                    [items]="probationStatus"
                    [border]="isEditable ? 'classic' : 'none'"
                    [isEditMode]="isEditable"
                  ></app-dropdown>
                </div></div
            ></ng-container>
            <div class="row mb-3">
              <label
                class="col-sm-12 mb-3"
                appMarkAsterisk
                [formGroup]="form"
                [controlName]="'commentFromRecruiter'"
                [touched]="form.get('commentFromRecruiter')!.touched"
                >Comment from the Recruiter</label
              >
              <div class="col-10">
                <div class="textarea__wrapper col-sm-12">
                  <textarea
                    type="textarea"
                    class="input__basic input__textarea"
                    [class.disable-field]="!isRecruiter"
                    placeholder=" "
                    formControlName="commentFromRecruiter"
                  ></textarea>
                  <app-error-field
                    [displayError]="
                      form.get('commentFromRecruiter')!.hasError('maxlength')
                    "
                    [errorMessage]="'Max field length = 1000 symbols'"
                  ></app-error-field>
                  <ng-container *ngIf="isHrManager || isRecruiter || isCEO">
                    <img
                      *ngIf="!commentFile.value"
                      class="empty_doc icon"
                      src="assets/icons/svg/attach_document/none.svg"
                      alt="link-empty"
                      (click)="inputCommentFile.click()"
                      [style.pointerEvents]="isEditable ? 'auto' : 'none'"
                    />
                    <input
                      type="file"
                      (change)="handleCommentFileInput($event)"
                      accept="application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf"
                      hidden
                      #inputCommentFile
                    />
                    <a [href]="commentSrc" target="_blank"
                      ><img
                        *ngIf="commentFile.value"
                        class="attached_doc icon"
                        src="assets/icons/svg/attached_document/normal.svg"
                        alt="link"
                    /></a>
                    <i
                      *ngIf="commentFile.value"
                      class="icon-download-normal icon blue"
                      (click)="downloadBlobFile(commentFile.value, 'data')"
                    ></i>
                    <i
                      *ngIf="isEditable && commentFile.value"
                      class="icon-close icon blue small-close"
                      (click)="removeCommentFile()"
                    ></i>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="row mb-3" *ngIf="!isHiddenForRecruiter">
              <label
                class="col-sm-12 mb-3"
                appMarkAsterisk
                [formGroup]="form"
                [controlName]="'comment'"
                [touched]="form.get('comment')!.touched"
                >Comment</label
              >
              <div class="col-10 general_form_input">
                <textarea
                  type="textarea"
                  class="input__basic input__textarea"
                  placeholder=" "
                  formControlName="comment"
                ></textarea>
                <app-error-field
                  [displayError]="form.get('comment')!.hasError('maxlength')"
                  [errorMessage]="'Max field length = 1000 symbols'"
                ></app-error-field>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
  </form>

  <i
    class="icon-pencil"
    (click)="onEdit($event)"
    [class.grey]="isEditable"
    *ngIf="ableToEdit"
  ></i>
  <button
    class="button button__save profile__button"
    *ngIf="isEditable"
    (click)="save()"
    #saveButton
  >
    Save
  </button>
</div>
